let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cn8a4")).then(() => parcelRequire('gAJPK'));